class ERProductPreview {
  constructor(root) {
    this.root = root;
    this.dialog = root.querySelector('[data-er-product-preview-dialog]');
    this.image = this.dialog?.querySelector('img');
    this.bind();
  }

  bind() {
    if (!this.dialog || !this.image) return;

    this.root.querySelectorAll('[data-er-product-preview-open]').forEach((button) => {
      button.addEventListener('click', () => {
        this.image.src = button.dataset.image;
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      });
    });

    this.root.querySelector('[data-er-product-preview-close]')?.addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
  }
}

const initERProductPreviews = (scope = document) => {
  scope.querySelectorAll('[data-er-product-preview]').forEach((root) => {
    if (root.dataset.erProductPreviewInitialized) return;
    root.dataset.erProductPreviewInitialized = 'true';
    new ERProductPreview(root);
  });
};

document.addEventListener('DOMContentLoaded', () => initERProductPreviews());
document.addEventListener('shopify:section:load', (event) => initERProductPreviews(event.target));
